.settingsKeywords {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	width: 100%;
	min-width: 0;
}

